<template>
    <div>
        <div v-if="isBusy" class="main-loader main-loader--absolute">
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
        <v-form ref="formData" class="form-data" @submit.prevent="onSubmit()">
            <v-app-bar flat color="white" height="72" class="px-3" fixed app>
                <router-link to="/user-access" style="text-decoration: none; color: inherit"><v-icon left x-large class="pa-4"> mdi-arrow-left </v-icon></router-link>
                <h2 class="d-flex align-center">{{ action == 'invite-user' ? 'Invite User' : action == 'edit' ? 'Edit User' : form.full_name }}</h2>
                <small :class="['active-status status active', { active: form.is_active }, 'mx-4 px-2 py-1 px-4']" v-if="action == 'view'">{{ form.status | uppercaseFirst }}</small>

                <v-card flat class="ml-auto">
                    <v-btn :to="`/user-access/users/edit/${this.$route.params.id}`" class="mx-1" outlined text @click="editDetails()" v-if="action == 'view'"
                        ><v-icon small>mdi-square-edit-outline</v-icon> Edit System Variable</v-btn
                    >
                    <v-btn class="mx-1" @click="cancelAction()" outlined text v-else>Cancel</v-btn>
                    <v-btn type="submit" color="primary" :class="['mx-1', { disabled: action == 'view' }]"
                        ><v-icon left v-if="action == 'invite-user'"> mdi-plus </v-icon> {{ action == 'invite-user' ? 'Invite' : 'Save' }}</v-btn
                    >
                </v-card>
            </v-app-bar>
            <v-container fluid class="pa-5" id="">
                <v-row>
                    <v-col cols="12" md="8" class="px-8 pt-8 pb-0">
                        <div class="card px-8 pt-5 pb-6 white rounded-lg" v-if="action == 'view'">
                            <h3 class="mb-10">System Variable Information</h3>
                            <v-row>
                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Email Address</div>
                                    <div>{{ form.email }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Name</div>
                                    <div>{{ form.full_name }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Role</div>
                                    <div>{{ (form.role || {}).name }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <template>
                                        <div>Company</div>
                                        <div>{{ form.company }}</div>
                                    </template>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Mobile number</div>
                                    <div>{{ form.mobile ? `0${form.mobile}` : '' | formatPhoneNumber | formatMobileNumber }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Last Access</div>
                                    <div>{{ form.last_logged_in_at | formatDate }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail status">
                                    <div>Status</div>
                                    <div>
                                        <v-switch
                                            v-model="form.is_active"
                                            :label="form.is_active ? 'Active' : 'Deactivated' | uppercaseFirst"
                                            color="success"
                                            :class="['font-weight-light', { 'switch-status-active': form.is_active }]"
                                            hide-details
                                            inset
                                        ></v-switch>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-else>
                            <h3 class="mb-8">User Detail</h3>

                            <v-row class="my-0">
                                <v-col cols="12" md="12" class="py-0">
                                    <label for="email" class="font-weight-medium">Email Address</label>
                                    <v-text-field v-model="form.email" :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.email }]" :error-messages="errors.email" hide-details="auto" solo dense></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="my-0">
                                <v-col cols="12" md="6" class="py-0">
                                    <label for="name" class="font-weight-medium">First Name</label>
                                    <v-text-field
                                        v-model="form.first_name"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.first_name }]"
                                        :error-messages="errors.first_name"
                                        placeholder="eg. John"
                                        hide-details="auto"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                    <label for="name" class="font-weight-medium">Last Name</label>
                                    <v-text-field
                                        v-model="form.last_name"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.last_name }]"
                                        :error-messages="errors.last_name"
                                        placeholder="eg. Doe"
                                        hide-details="auto"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row class="my-0">
                                <v-col cols="12" md="12" class="py-0">
                                    <label for="company" class="font-weight-medium">Role</label>
                                    <v-select
                                        v-model="selected"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.role_id }]"
                                        :error-messages="errors.role_id"
                                        item-text="name"
                                        :items="roles"
                                        return-object
                                        hide-details="auto"
                                        @change="changeRole"
                                        solo
                                        dense
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <v-row class="my-0">
                                <v-col cols="12" md="12" class="py-0">
                                    <div class="role-required-fields">
                                        <template v-if="selected.id == 'PARTNER'">
                                            <label for="partner" class="font-weight-medium">Partner</label>
                                            <v-text-field
                                                v-model="form.company"
                                                :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.company }]"
                                                :error-messages="errors.company"
                                                hide-details="auto"
                                                solo
                                                dense
                                            ></v-text-field>
                                        </template>

                                        <template v-if="selected.id == 'MERCHANT'">
                                            <label for="merchant" class="font-weight-medium">Merchant</label>
                                            <v-select
                                                v-model="merchant"
                                                :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.merchant_id }]"
                                                :error-messages="errors.merchant_id"
                                                item-text="name"
                                                item-value="id"
                                                :items="merchants"
                                                hide-details="auto"
                                                solo
                                                dense
                                            ></v-select>
                                        </template>

                                        <template v-if="selected.id != 'MERCHANT' && selected.id != 'PARTNER'">
                                            <v-row class="my-0">
                                                <v-col cols="12" md="12" class="py-0">
                                                    <label for="company" class="font-weight-medium">Company</label>
                                                    <v-text-field
                                                        v-model="form.company"
                                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.company }]"
                                                        :error-messages="errors.company"
                                                        hide-details="auto"
                                                        solo
                                                        dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row class="my-0" v-if="action == 'edit'">
                                <v-col cols="12" md="12" class="py-0">
                                    <label for="mobile" class="font-weight-medium">Mobile Number</label>
                                    <v-text-field v-model="form.mobile" :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.mobile }]" :error-messages="errors.mobile" hide-details="auto" solo dense></v-text-field>
                                </v-col>
                            </v-row>

                            <div class="card d-flex align-center my-4 px-8 py-5 white rounded-lg">
                                <v-row>
                                    <v-col cols="8" class="font-weight-bold">Status</v-col>
                                    <v-col cols="4">
                                        <v-switch
                                            v-model="is_active"
                                            :label="is_active ? 'Active' : 'Deactivated' | uppercaseFirst"
                                            color="success"
                                            :class="['float-right', { 'switch-status-active': is_active }]"
                                            hide-details="auto"
                                            inset
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>

                        <div class="card d-flex align-center my-4 px-8 py-5 white rounded-lg" v-if="action != 'invite-user'">
                            <span class="font-weight-bold">Delete this User</span>
                            <v-btn
                                color="error"
                                class="ml-auto float-right"
                                @click="
                                    confirmAction({
                                        action: 'delete',
                                        data: {
                                            id: $route.params.id
                                        }
                                    })
                                "
                                elevation="0"
                                >Delete</v-btn
                            >
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>

        <v-dialog v-model="confirmDialog.show" scrollable max-width="540" color="primaryBackgroundColor" transition="scroll-y-reverse-transition" persistent>
            <v-card class="confirm-dialog">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon class="dialog-close" v-on="on" @click="confirmDialog.show = false" :disabled="confirmStatusLoading">close</v-icon>
                    </template>
                    <span>Close</span>
                </v-tooltip>
                <v-card-title class="pb-2 font-weight-bold">
                    {{ confirmDialog.data.modalTitle }}
                </v-card-title>
                <v-card-text class="pb-2">
                    <p class="font-size-21 ma-0">
                        {{ confirmDialog.data.modalDescription }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-container fluid>
                        <v-row align="center" justify="center">
                            <v-col cols="6" class="d-flex justify-center">
                                <v-btn
                                    class="btn-min-width"
                                    text
                                    :disabled="confirmStatusLoading"
                                    @click="
                                        modalAction({
                                            action: 'cancel',
                                            data: confirmDialog.data
                                        })
                                    "
                                    height="45"
                                    block
                                    outlined
                                >
                                    No, cancel
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="d-flex justify-center">
                                <v-btn
                                    class="confirm-btn btn-min-width"
                                    depressed
                                    :color="confirmDialog.action == 'delete' || !confirmDialog.data.is_active ? 'error' : 'primary'"
                                    :loading="confirmStatusLoading"
                                    @click="
                                        modalAction({
                                            action: confirmDialog.action,
                                            data: confirmDialog.data
                                        })
                                    "
                                    height="45"
                                    block
                                >
                                    Yes, {{ confirmDialog.action == 'delete' ? 'Delete' : confirmDialog.data.is_active ? 'Activate' : 'Deactivate' }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'UserAccessAction',
    data() {
        return {
            action: 'invite-user',
            is_active: true,
            permissions: {},
            confirmDialog: { show: false, action: '', data: {}, status: '' },
            confirmStatusLoading: false,
            form: {}
        };
    },
    created() {
        this.action = this.$route.params.action;

        switch (this.action) {
            case 'edit':
                this.getSystemVariableDetails();
                break;
            case 'view':
                this.getSystemVariableDetails();
                break;
        }

        this.setIsBusy(true);
    },
    computed: {
        ...mapGetters({
            userDetails: 'users/getUserDetails'
        })
    },
    watch: {
        $route(to, from) {
            if (from.params.action == 'edit') {
                this.setIsBusy(true);
                this.getSystemVariableDetails();
                this.getRoles();
            }
        }
    },
    methods: {
        editDetails() {
            this.action = 'edit';
            this.getRoles();
        },
        cancelAction() {
            if (this.action == 'edit') {
                this.action = 'view';
                this.form = this.userDetails;
                this.$router.push(`/user-access/users/view/${this.$route.params.id}`);
            } else {
                this.$router.push({ name: 'user-access' });
            }
        },
        confirmAction({ action, data }) {
            switch (action) {
                case 'delete':
                    data.modalTitle = `Are you sure you want to delete user ${this.form.full_name}?`;
                    data.modalDescription = 'Deleting this would mean lorem ipsum dolor.';
                    this.confirmDialog = { show: true, action, data };
                    break;
            }
        },
        modalAction({ action, data }) {
            switch (action) {
                case 'delete':
                    this.form.confirmation = 1;
                    this.deleteUser(data);
                    break;

                case 'cancel':
                    this.confirmDialog.show = false;
                    break;
            }
        },
        changeRole() {
            if (this.selected.id == 'MERCHANT') {
                this.getMerchantDropdown();
            }
        },
        deleteUser() {
            this.confirmStatusLoading = true;

            this.$store
                .dispatch('users/deleteUser', {
                    id: this.$route.params.id,
                    config: {
                        params: { ...this.form }
                    }
                })
                .then((response) => {
                    this.confirmStatusLoading = false;
                    this.$router.push({ name: 'user-access' });
                    this.notification({ type: 'success', message: response.message });
                })
                .catch(() => {
                    this.confirmStatusLoading = false;
                });
        },
        getSystemVariableDetails() {
            this.setIsBusy(false);
            this.$store
                .dispatch('users/findUser', {
                    id: this.$route.params.id,
                    config: {
                        params: {
                            'appends[0]': 'role',
                            'appends[1]': 'merchant'
                        }
                    }
                })
                .then((response) => {
                    //this.form = response.data;
                    this.permissions = response.data.role.permissions;
                    this.selected = response.data.role;
                })
                .catch(() => {
                    this.setIsBusy(false);
                    this.$router.push({ name: 'user-access' });
                });
        },

        onSubmit() {
            let dispatch;
            switch (this.action) {
                case 'add':
                    dispatch = 'systemVariables/addSystemVariable';
                    break;
                case 'edit':
                    dispatch = 'systemVariables/updateSystemVariable';
                    break;
            }

            this.setIsBusy(true);
            this.form.status = this.is_active ? 'ACTIVE' : 'INACTIVE';

            this.$store
                .dispatch(dispatch, {
                    id: this.$route.params.id,
                    config: {
                        params: { ...this.form }
                    }
                })
                .then((response) => {
                    this.setIsBusy(false);
                    this.notification({ type: 'success', message: response.message });

                    if (this.$route.params.id) {
                        this.action = 'view';
                        this.$router.push(`/user-access/users/view/${this.$route.params.id}`);
                    } else {
                        this.$router.push({ name: 'user-access' });
                    }
                })
                .catch(() => {
                    this.setIsBusy(false);
                });
        }
    }
};
</script>

<style lang="scss" scoped></style>
